import {Component, ErrorInfo, ReactNode} from 'react';
import './error-boundary.scss';

interface Props {
    children: ReactNode;
    onError?: (hasError: boolean) => void;
}

interface State {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class NetworkOptimizationErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error: Error): State {
        return {
            hasError: true,
            error,
            errorInfo: null
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            error,
            errorInfo
        });
        // Notify parent that an error occurred
        if (this.props.onError) {
            this.props.onError(true);
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='network-optimization-error-boundary'>
                    <div className='error-content'>
                        <div className='error-icon'>
                            <svg
                                width='80'
                                height='80'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
                                    fill='#da1e28'
                                />
                            </svg>
                        </div>
                        <h1 className='error-title'>Something went wrong</h1>
                        <p className='error-message'>
                            We encountered an unexpected error in Network Optimization. Please use the navigation menu to continue.
                        </p>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default NetworkOptimizationErrorBoundary;
